import {miniPlayerSvg as Icon__small__miniPlayerSvg} from '../Icon__small/Icon__small--miniPlayer.js';

export var miniPlayer = {
  name: 'miniPlayer',
  category: 'icon',
  colorable: true,
  svg: Icon__small__miniPlayerSvg,
};
